// extracted by mini-css-extract-plugin
export default {"noPadding":"styles_noPadding__25tkm","centerContent":"styles_centerContent__gJ2Wm","loading":"styles_loading__rRnQ2"};